import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

import ScreenLayout from "components/ScreenLayout";
import HeaderComponents from "./components/HeaderComponents";
import DoughnutChart from "./components/DoughnutChart";

import "./Dashboard.scss";
import axios from "axios";
import { baseUrl, headers } from "../../lib/api/constants";
import PieChart from "./components/PieChart";
import ReadyForSaleChart from "./components/ReadyForSaleChart";
import VerticalChart from "./components/VerticalChart";
import { CircularProgress } from "@material-ui/core";

const Dashboard = () => {
  const [data, setData] = useState([]);
  const [dataCategories, setDataCategories] = useState([]);
  const [dataStatuses, setDataStatuses] = useState([]);
  const [dataItemsReadyForSale, setDataItemsReadyForSale] = useState([]);
  const [dataItemsSold, setDataItemsSold] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const searchParams = queryString.parse(location.search);
  const fetchIdRef = useRef(0);

  const { authObject } = useSelector(({ authReducer }) => authReducer);

  async function getDataDashboard() {
    setLoading(true);
    const fetchId = ++fetchIdRef.current;

    const params = new URLSearchParams();
    if (searchParams.clientId) {
      params.append('clientId', searchParams.clientId);
    }
    
    const url = `${baseUrl}/dashboard${params.toString() ? '?' + params.toString() : ''}`;
    const response = await axios
      .get(url, {
        method: "GET",
        headers: {
          ...headers,
          ...(authObject?.token ? { Authorization: `Bearer ${authObject.token}` } : {})
        },
      })
      .catch((err) => console.log(err));

    if (response?.data && fetchId === fetchIdRef.current) {
      setLoading(false);
      setData(response.data);
      // eslint-disable-next-line array-callback-return
      response.data.map((resp) => {
        if (resp.category) {
          setDataCategories(resp.category);
        }
        if (resp.status) {
          setDataStatuses(resp.status);
        }
        if (resp.itemReadyForSale) {
          setDataItemsReadyForSale(resp.itemReadyForSale);
        }
        if (resp.itemsSold) {
          setDataItemsSold(resp.itemsSold);
        }
      });
    }
  }

  useEffect(() => {
    getDataDashboard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alingItems: "center",
        }}
      >
        <CircularProgress color={"secondary"} />
      </div>
    );
  }

  return (
    <ScreenLayout headerComponents={HeaderComponents}>
      <div className="containerCharts">
        <div className="containerChart">
          <DoughnutChart itemForCategory={dataCategories} />
        </div>
        <div className="containerChart">
          <PieChart itemForStatus={dataStatuses} />
        </div>
        <div className="containerChart">
          <ReadyForSaleChart dataItemsReadyForSale={dataItemsReadyForSale} />
          <br />
          <VerticalChart dataItemsSold={dataItemsSold} />
        </div>
      </div>
    </ScreenLayout>
  );
};

export default Dashboard;
